import type * as Types from 'app/types/graphql';

import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type CampaignGroupDeleteMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type CampaignGroupDeleteMutationResponse = Pick<Types.Mutation, 'campaignGroupDelete'>;

export const CampaignGroupDeleteDocument = `
    mutation CampaignGroupDelete($id: ID!) {
  campaignGroupDelete(id: $id)
}
    `;

export const useCampaignGroupDeleteMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CampaignGroupDeleteMutationResponse,
    TError,
    CampaignGroupDeleteMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CampaignGroupDeleteMutationResponse,
    TError,
    CampaignGroupDeleteMutationVariables,
    TContext
  >(
    ['CampaignGroupDelete'],
    (variables?: CampaignGroupDeleteMutationVariables) =>
      appFetcher<CampaignGroupDeleteMutationResponse, CampaignGroupDeleteMutationVariables>(
        CampaignGroupDeleteDocument,
        variables,
      )(),
    options,
  );
};

useCampaignGroupDeleteMutation.getKey = () => ['CampaignGroupDelete'];
